import React, { useState, useEffect } from "react";
import Box from "../../../components/dashboard/Box";
import Header from "../../../layout/Header";
import Sidebar from "../../../layout/Sidebar";
import { Spin, Collapse } from "antd";
import Bridge from "../../../constants/Bridge";

const accordionText = `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
  molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum
  numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium
  optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis
  obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam
  nihil, eveniet aliquid culpa officia aut! Impedit sit sunt quaerat, odit,
  tenetur error, harum nesciunt ipsum debitis quas aliquid. Reprehenderit,
  quia. Quo neque error repudiandae fuga? Ipsa laudantium molestias eos 
  sapiente officiis modi at sunt excepturi expedita sint? Sed quibusdam
  recusandae alias error harum maxime adipisci amet laborum. Perspiciatis 
  minima nesciunt dolorem! Officiis iure rerum voluptates a cumque velit 
  quibusdam sed amet tempora. Sit laborum ab, eius fugit doloribus tenetur 
  fugiat, temporibus enim commodi iusto libero magni deleniti quod quam 
  consequuntur! Commodi minima excepturi repudiandae velit hic maxime
  doloremque. Quaerat provident commodi consectetur veniam similique ad 
  earum omnis ipsum saepe, voluptas, hic voluptates pariatur est explicabo 
  fugiat, dolorum eligendi quam cupiditate excepturi mollitia maiores labore 
  suscipit quas? Nulla, placeat. Voluptatem quaerat non architecto ab laudantium
  modi minima sunt esse temporibus sint culpa, recusandae aliquam numquam 
  totam ratione voluptas quod exercitationem fuga. Possimus quis earum veniam 
  quasi aliquam eligendi, placeat qui corporis!`;

const Main = () => {
  const [totalAudioRated, setTotalAudioRated] = useState(0);
  const [loading, setLoading] = useState(false);
  const [getActiveLink, setGetActiveLink] = useState(true);

  // on load component function
  useEffect(() => {
    getDashboardData();
  }, []);
  // get dashboard counts
  const getDashboardData = () => {
    setLoading(true);
    Bridge.slp_substudy
      .dashboard()
      .then((result) => {
        if (result.status == "1") {
          console.log("result", result);
          setTotalAudioRated(result.data.total_audios_rated);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error: ", err);
        setLoading(false);
      });
  };
  const onChange = (key) => {
    console.log(key);
  };
  const items = [
    {
      key: "1",
      label: "Synopsis",
      children: (
        <div className="accordion-content">
          <p>{accordionText}</p>
        </div>
      ),
    },
  ];
  return (
    <div>
      <div>
        <Header />
        <div className="row">
          <Sidebar />
          <div
            className="col-lg-10"
            style={{
              minHeight: "100vh",
              paddingLeft: "32px",
              paddingRight: "30px",
              marginLeft: "auto",
              backgroundColor: "#F5F5F5",
            }}
          >
            <Spin spinning={loading}>
              <div
                className="main-section dashboard"
                style={{ marginTop: 105 }}
              >
                <div>
                  <p
                    style={{
                      position: "relative",
                      fontSize: 32,
                      fontFamily: "Open Sans",
                      fontWeight: "bold",
                      color: "#1A4F83",
                      textAlign: "start",
                    }}
                    className="mb-4 mt-4"
                  >
                    SLP Substudy
                  </p>
                  <p
                    style={{
                      position: "relative",
                      fontSize: 20,
                      fontFamily: "Open Sans",
                      fontWeight: "bold",
                      color: "#1A4F83",
                      textAlign: "start",
                    }}
                    className="mb-4"
                  >
                    REAL TIME STUDY STATISTICS
                  </p>
                  <div className="synopsis-accordion">
                    <div className="row" style={{ padding: "2%" }}>
                      <Collapse
                        items={items}
                        defaultActiveKey={[]}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      backgroundColor: "white",
                      padding: "2%",
                      borderRadius: "19px",
                      maxWidth: "100%",
                      alignItems: "center",
                    }}
                  >
                    <div className="row" style={{ padding: "2%" }}>
                      <div className="col-lg-3">
                        <a
                          href="#!"
                          style={{
                            fontWeight: "regular",
                            fontSize: "18",
                          }}
                          // className={`active-links ${
                          //   getActiveLink ? "active" : ""
                          // }`}
                        >
                          <Box
                            title="Total Audios Rated"
                            count={totalAudioRated}
                            getActiveLink={getActiveLink}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
